import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-center my-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-center my-1"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}
const _hoisted_4 = { class: "text-danger my-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "text-end" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner")
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_th = _resolveComponent("b-th")
  const _component_b_tr = _resolveComponent("b-tr")
  const _component_b_table = _resolveComponent("b-table")
  const _component_b_popover = _resolveComponent("b-popover")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_b_table, {
        id: "individual-hours-table",
        ref: "individualHoursTable",
        busy: $data.isBusy,
        "onUpdate:busy": _cache[1] || (_cache[1] = $event => (($data.isBusy) = $event)),
        bordered: "",
        striped: "",
        hover: "",
        small: "",
        "head-variant": "dark",
        "primary-key": "contractId",
        fields: $data.fields,
        items: $data.items,
        "show-empty": ""
      }, {
        "table-busy": _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_b_spinner, {
              small: "",
              type: "grow",
              variant: "secondary"
            }),
            _createVNode(_component_b_spinner, {
              style: {"animation-delay":"0.1s"},
              small: "",
              type: "grow",
              variant: "secondary"
            }),
            _createVNode(_component_b_spinner, {
              style: {"animation-delay":"0.2s"},
              small: "",
              type: "grow",
              variant: "secondary"
            })
          ])
        ]),
        empty: _withCtx(() => [
          (!$data.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Keine passenden Ergebnisse gefunden. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, " Ein Fehler ist aufgetreten (" + _toDisplayString($data.error.message) + "). ", 1 /* TEXT */),
                _createVNode(_component_b_button, {
                  onClick: _cache[0] || (_cache[0] = $event => ($options.fetchData()))
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "fa-solid fa-rotate-right me-1" }, null, -1 /* CACHED */),
                    _createTextVNode("Erneut versuchen. ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]))
        ]),
        "cell(coursesCL1)": _withCtx(({index, value : courses}) => [
          (courses.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  title: courses,
                  class: "text-center"
                }, [
                  _createVNode(_component_b_button, {
                    id: 'courses-cl1-' + index,
                    size: "sm",
                    class: "text-nowrap"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Anzeigen (" + _toDisplayString(courses.length) + ") ", 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]),
                  _createVNode(_component_b_popover, {
                    target: 'courses-cl1-' + index,
                    placement: "left",
                    click: "",
                    lazy: ""
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[5] || (_cache[5] = _createTextVNode(" Kurse VGS 1 ", -1 /* CACHED */)),
                        _createVNode(_component_b_button, {
                          title: "Veranstaltungstitel kopieren",
                          size: "sm",
                          class: "btn-smaller",
                          onClick: $event => ($options.copyTitles(courses.map((course) => course.name)))
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("i", { class: "fas fa-copy" }, null, -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_b_table, {
                        fields: [{key: 'name', label: 'Veranstaltungstitel'}, {key: 'calculatedWorkload', label: 'Stunden'}],
                        items: courses,
                        borderless: "",
                        small: "",
                        variant: "secondary",
                        "head-variant": "light",
                        class: "mb-0",
                        "primary-key": "id",
                        "sort-by": [{key: 'name', order: 'asc'}]
                      }, {
                        "cell(name)": _withCtx(({item}) => [
                          _createElementVNode("a", {
                            href: $props.courseBaseUrl + '/' + item.id + '/view',
                            target: "_blank"
                          }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_8)
                        ]),
                        "cell(calculatedWorkload)": _withCtx(({value}) => [
                          _createElementVNode("div", _hoisted_9, _toDisplayString($options.formatDuration(value)), 1 /* TEXT */)
                        ]),
                        "custom-foot": _withCtx(({items : footerItems}) => [
                          _createVNode(_component_b_tr, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_th, { style: {"background-color":"white"} }),
                              _createVNode(_component_b_th, { class: "text-end" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($options.formatDuration($options.weekhourSum(footerItems))), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["items"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["target"])
                ], 8 /* PROPS */, _hoisted_6)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        "cell(coursesCL2)": _withCtx(({index, value : courses}) => [
          (courses.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  title: courses,
                  class: "text-center"
                }, [
                  _createVNode(_component_b_button, {
                    id: 'courses-cl2-' + index,
                    size: "sm",
                    class: "text-nowrap"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Anzeigen (" + _toDisplayString(courses.length) + ") ", 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]),
                  _createVNode(_component_b_popover, {
                    target: 'courses-cl2-' + index,
                    placement: "right",
                    click: "",
                    lazy: ""
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _cache[7] || (_cache[7] = _createTextVNode(" Kurse VGS 2 ", -1 /* CACHED */)),
                        _createVNode(_component_b_button, {
                          title: "Veranstaltungstitel kopieren",
                          size: "sm",
                          class: "btn-smaller",
                          onClick: $event => ($options.copyTitles(courses.map((course) => course.name)))
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "fas fa-copy" }, null, -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_b_table, {
                        fields: [{key: 'name', label: 'Veranstaltungstitel'}, {key: 'calculatedWorkload', label: 'Stunden'}],
                        items: courses,
                        borderless: "",
                        small: "",
                        variant: "secondary",
                        "head-variant": "light",
                        class: "mb-0",
                        "primary-key": "id",
                        "sort-by": [{key: 'name', order: 'asc'}]
                      }, {
                        "cell(name)": _withCtx(({item}) => [
                          _createElementVNode("a", {
                            href: $props.courseBaseUrl + '/' + item.id + '/view',
                            target: "_blank"
                          }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_13)
                        ]),
                        "cell(calculatedWorkload)": _withCtx(({value}) => [
                          _createElementVNode("div", _hoisted_14, _toDisplayString($options.formatDuration(value)), 1 /* TEXT */)
                        ]),
                        "custom-foot": _withCtx(({items : footerItems}) => [
                          _createVNode(_component_b_tr, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_th, { style: {"background-color":"white"} }),
                              _createVNode(_component_b_th, { class: "text-end" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($options.formatDuration($options.weekhourSum(footerItems))), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["items"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["target"])
                ], 8 /* PROPS */, _hoisted_11)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        "custom-foot": _withCtx(() => [
          _createVNode(_component_b_tr, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_th, { colspan: "3" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Summe: ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_b_th, { class: "text-end" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.formatDuration($options.columnSums['compensationLevel1'])), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_b_th, { class: "text-end" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.formatDuration($options.columnSums['compensationLevel2'])), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_b_th, { class: "text-end" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.formatDuration($options.columnSums['compensationLevels'])), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["busy", "fields", "items"])
    ]),
    _createVNode(_component_b_button, {
      class: "float-end",
      title: $options.durationFormatTooltipText,
      onClick: _cache[2] || (_cache[2] = $event => ($data.formatDurationsAsHours = !$data.formatDurationsAsHours))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString($data.formatDurationsAsHours ? '[hh:mm]' : '[h]'), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"])
  ], 64 /* STABLE_FRAGMENT */))
}